import { Component } from '@angular/core';
import { TcPage } from '@tc/core';

@Component({
  selector: 'app-terms-conditions-page',
  templateUrl: './terms-conditions-page.component.html',
  styleUrls: ['./terms-conditions-page.component.scss'],
})
export class TermsConditionsPageComponent extends TcPage {
  constructor() {
    super();
  }
}
